import Vue from 'vue'
import CoupangProducts from '@/widgets/apps/CoupangProducts.vue'
import vueCustomElement from 'vue-custom-element'
import 'document-register-element/build/document-register-element'
import moment from 'moment'

Vue.config.productionTip = false

Vue.use(vueCustomElement)
Vue.customElement('coupang-products', CoupangProducts)
